import { delay, lowerCase } from "lodash";
import Swal from "sweetalert2";
import { ModuleEvents } from "./Actions";
import { Actions } from "../../internals/app/Actions";
import withReactContent from "sweetalert2-react-content";

export default {
  [ModuleEvents.CREATE_DISCOUNT]: ({ dispatch, payload, appState }) => {
    if (payload && !payload.error) {
      dispatch(Actions.common.openAlertBox("CREATE", true, "SUCCESS"));
      delay(function (text) {
        dispatch(Actions.common.openAlertBox("CREATE", false, "SUCCESS"));
      }, 3000);
    } else {
      return warning("Discount created unsuccessfully!");
    }
  },

  [ModuleEvents.UPDATE_DISCOUNT]: ({ dispatch, payload, appState }) => {
    const { result, status } = payload;
    if (result && !result.error) {
      dispatch(Actions.common.openAlertBox(status, true, "SUCCESS"));
      delay(function (text) {
        dispatch(Actions.common.openAlertBox(status, false, "SUCCESS"));
      }, 3000);
    } else {
      return warning(`Discount ${lowerCase(status)} unsuccessfully!`);
    }
  },
};

const warning = (alert) => {
  const MySwal = withReactContent(Swal);
  MySwal.fire({
    icon: "error",
    text: alert,
    title: "Oops...",
    showCancelButton: true,
    showConfirmButton: false,
    cancelButtonColor: "#FF3333",
  });
};
